// extracted by mini-css-extract-plugin
module.exports = {"strain":"Strain_strain__KCHBz","fullStrainName":"Strain_fullStrainName__pJ9oT"};